import * as React from "react";

import { Link } from "common/types/routing";

import InternalRedirectOnlyRoute from "features/common/routing/InternalRedirectOnlyRoute";

import matchEndOfPath from "./matchEndOfPath";

type Props = {
  children: React.ReactElement;
  redirectLink: Link;
  pathEndsWith: string;
  exact?: boolean;
};

export default function InternalRedirectOnlyPathEndsWithRoute({
  children,
  pathEndsWith,
  ...otherProps
}: Props) {
  return (
    <InternalRedirectOnlyRoute
      {...otherProps}
      // @ts-ignore
      matchPath={matchEndOfPath}
      path={pathEndsWith}
    >
      {children}
    </InternalRedirectOnlyRoute>
  );
}
